import { DocumentTemplateType } from '@lmt/shared-types';
import { assertNever } from '@lmt/unicorn-shared/app/helpers/assert-never';
import {
  DXR,
  RichEdit,
  DocumentFormat,
} from '../../../common/devexpress/RichEdit/dx-richedit';

export const defaultDocumentName = 'document1';

export const saveAsTemplateMenuId = 'saveAsTemplateMenuId';

/*
Returns true if document was not ever saved
 */
export function isDocumentNew(sender: RichEdit): boolean {
  // that's quite strange, but there seems to be no other way. Will ask support
  return sender.fileName === defaultDocumentName;
}

export function isDocumentType(type: DocumentTemplateType) {
  return (
    type === DocumentTemplateType.Document ||
    type === DocumentTemplateType.DocumentHeader ||
    type === DocumentTemplateType.DocumentFooter
  );
}

export function getFileNameWithFormat(
  fileName: string,
  format: DocumentFormat,
): string {
  switch (format) {
    case DXR.DocumentFormat.PlainText:
      return `${fileName}.txt`;
    case DXR.DocumentFormat.Rtf:
      return `${fileName}.rtf`;
    case DXR.DocumentFormat.OpenXml:
      return `${fileName}.docx`;
    case DXR.DocumentFormat.Html:
      return `${fileName}.html`;
    default:
      assertNever(format);
  }
}
